export const OVERVIEW = 'overview';
export const DESCRIPTION = 'description';
export const FAQ = 'faq';
export const REVIEWS = 'reviews';
export const ORDER_DETAILS = 'orderDetails';
export const RECOMMENDATIONS = 'recommendations';
export const ABOUT_SELLER = 'aboutSeller';
export const PACKAGES_TABLE = 'packagesTable';
